







import Vue from 'vue'

export default Vue.extend({
  name: 'SampleRibbon',

  props: {
    /* small, medium, or large */
    size: {
      type: String,
      default: 'large',
    },
  },
})
